import { Map } from 'immutable';
import { FILL_SELL_ORDERS, FILL_SELL_ORDER, FILL_SELL_ORDER_CARDS,
				 RESET, RESET_EXPIRE, RESET_SELL, RESET_SELL_ORDER,
				 RESET_SELL_ORDER_CARDS, CLEAR_SELL_ORDERS,
				 SET_SELL_ORDER_TO_CANCEL, SELL_ORDERS_THUNK_RUNNING,
				 SET_ORDER_TOTAL, SELL_ORDER_THUNK_RUNNING, SELL_CARDS_THUNK_RUNNING
			 } from '../constants/actionTypes.js';

const initialState = Map({
	sellOrders: [],
	sellOrder: {},
	sellOrderCards: [],
	sellOrderToCancel: null,
	sellOrderTotal: 0,
	_sellOrdersThunkRunning: false,	
	_sellOrderThunkRunning: false,
	_sellCardsThunkRunning: false,
});

export default (state = initialState, action) => {

	switch (action.type) {

		case FILL_SELL_ORDERS:
      return state.set('sellOrders', action.payload.sellOrders);

		case FILL_SELL_ORDER:
			return state.set('sellOrder', action.payload.sellOrder);

		case FILL_SELL_ORDER_CARDS:
			return state.set('sellOrderCards', action.payload.sellCards);

		case SET_SELL_ORDER_TO_CANCEL:
			return state.set('sellOrderToCancel', action.payload);

		case RESET_SELL_ORDER:
			return state.set('sellOrder', {});

		case RESET_SELL_ORDER_CARDS:
			return state.set('sellOrderCards', []);

		case SET_ORDER_TOTAL:
			return state.set('sellOrderTotal', action.payload.orderTotal);

		case SELL_ORDERS_THUNK_RUNNING:
			return state.set('_sellOrdersThunkRunning', action.payload);

		case SELL_ORDER_THUNK_RUNNING:
			return state.set('_sellOrderThunkRunning', action.payload);

		case SELL_CARDS_THUNK_RUNNING:
			return state.set('_sellCardsThunkRunning', action.payload);

		case RESET:
		case RESET_EXPIRE:
		// case RESET_SELL:
		case CLEAR_SELL_ORDERS:
			return initialState;

		default:
			return state;
	}
};
